import React from "react";
import firebase from "../../firebase";
import {
  Item,
  Label,
  Header,
  Icon,
  Modal,
  Form,
  Button,
  Input,
  Grid,
  Segment,
  Divider,
  Container,
} from "semantic-ui-react";
import ReportDropdown from "./ReportDropdown";
import moment from "moment";
import InputTags from "./InputTags";
import Parser from "html-react-parser";
import ArticleTypesInfo from "./ArticleTypesInfo";
import ArticlesLikeButton from "./ArticlesLikeButton";
import { connect } from "react-redux";
import { isAdmin } from "../../adminUsers";
import { Editor } from "@tinymce/tinymce-react";

class Articles extends React.Component {
  state = {
    user: this.props.currentUser,
    articles: [],
    articlesRef: firebase.database().ref("articles"),
    usersRef: firebase.database().ref("users"),
    contentModal: false,
    typeModal: false,
    articleType: "",
    articleName: "",
    articleDetails: "",
    articleTags: [],
    bookmarkedArticles: [],
    filteredBookmarkedArticles: [],
    admin: this.props.admin && this.props.admin === true ? true : false,
  };

  componentDidMount() {
    this.addListeners();
  }

  componentWillUnmount() {
    this.removeListeners();
  }

  getArticlesRef = () => {
    return this.props.bookmarkedArticles
      ? this.state.usersRef.child(`${this.state.user.uid}/bookmarkedArticles`)
      : this.state.articlesRef;
  };

  addListeners = () => {
    let loadedArticles = [];
    this.getArticlesRef().on("child_added", (snap) => {
      let article = snap.val();
      article["uid"] = snap.key;
      loadedArticles.unshift(article);
      this.setState({ articles: loadedArticles });
    });

    let newArticlesList = [];
    this.getArticlesRef().on("child_removed", (snap) => {
      let article = snap.val();
      newArticlesList = this.state.articles.filter(
        (art) => art.id !== article.id
      );
      this.setState({ articles: newArticlesList });
      console.log(article);
    });

    // let loadedArticles = [];
    this.state.articlesRef.on("child_changed", (snap) => {
      let updatedArticle = snap.val();
      let updatedArticlesList = [...this.state.articles];
      let ind = updatedArticlesList.findIndex(
        (art) => art.id === updatedArticle.id
      );
      updatedArticlesList[ind] = updatedArticle;
      this.setState({ articles: updatedArticlesList });
      // console.log(snap.val())
    });

    this.addBookmarkedArticlesListeners(this.state.user.uid);
  };

  addBookmarkedArticlesListeners = (currentUserUid) => {
    let bmarticles = [];
    this.state.usersRef
      .child(`${this.state.user.uid}/bookmarkedArticles`)
      .on("child_added", (snap) => {
        let article = snap.val();
        article["added"] = false;
        article["key"] = snap.key;
        bmarticles.push(article);
        this.setState({ bookmarkedArticles: bmarticles });
      });

    bmarticles = [];
    this.state.usersRef
      .child(`${this.state.user.uid}/bookmarkedArticles`)
      .on("child_removed", (snap) => {
        let article = snap.val();
        article["uid"] = article.uid;
        bmarticles = this.state.bookmarkedArticles.filter(
          (f) => f.id !== article.id
        );
        this.setState({ bookmarkedArticles: bmarticles });
        if (this.props.bookmarkedArticles) {
          this.setState({ articles: bmarticles });
        }
      });
  };

  removeListeners = () => {
    this.getArticlesRef().off();
    this.state.usersRef
      .child(`${this.state.user.uid}/bookmarkedArticles`)
      .off();
  };

  getKey(article) {
    return this.state.bookmarkedArticles.find((f) => f.id === article.id).key;
  }

  isBookmarked(article) {
    return this.state.bookmarkedArticles.some((f) => {
      return f.id === article.id;
    });
  }

  addArticleToBookmark(art) {
    this.state.usersRef
      .child(`${this.state.user.uid}/bookmarkedArticles`)
      .push()
      .update(art)
      .then(() => {
        console.log("Article added");
        this.closeModal();
      })
      .catch((err) => console.error(err));
  }

  removeArticleToBookmark(art) {
    // console.log(user.uid)
    this.state.usersRef
      .child(`${this.state.user.uid}/bookmarkedArticles`)
      .child(`${this.getKey(art)}`)
      .remove()
      .then(() => {
        console.log("Article removed");
      })
      .catch((err) => console.error(err));
  }

  handleArticlesBookmark(article) {
    if (this.isBookmarked(article)) {
      this.removeArticleToBookmark(article);
    } else {
      this.addArticleToBookmark(article);
    }
  }

  addArticle = () => {
    const {
      articlesRef,
      articleName,
      articleType,
      articleDetails,
      articleTags,
      user,
    } = this.state;

    const key = articlesRef.push().key;

    const newArticle = {
      id: key,
      type: articleType,
      name: articleName,
      details: articleDetails,
      tags: articleTags,
      createdBy: {
        name: user.displayName,
        avatar: user.photoURL,
      },
      likes: 0,
      reported: false,
      timestamp: firebase.database.ServerValue.TIMESTAMP,
    };

    articlesRef
      .child(key)
      .update(newArticle)
      .then(() => {
        this.setState({ articleName: "", articleDetails: "", articleType: "" });
        this.closeModal();
        console.log("article added");
      })
      .catch((err) => {
        console.error(err);
      });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    if (this.isFormValid(this.state)) {
      this.addArticle();
    }
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleEditorChange = (content) => {
    this.setState({ articleDetails: content });
  };

  isFormValid = ({ articleName, articleDetails }) =>
    articleName && articleDetails;

  openModal = () => this.setState({ typeModal: true, contentModal: false });

  toggleModal(ind) {
    this.setState({
      typeModal: false,
      contentModal: true,
      channelType: ArticleTypesInfo[ind].name,
    });
  }

  closeModal = () => this.setState({ typeModal: false, contentModal: false });

  displayArticleTypes = (articles) =>
    articles.length > 0 &&
    articles.map((chn, ind) => (
      <Grid.Row key={ind} centered="true">
        <Button
          color={chn.color}
          inverted
          onClick={() => this.toggleModal(ind)}
          size="large"
          style={{ width: "50%" }}
        >
          <h1>{chn.name}</h1>
          <h5>{chn.description}</h5>
        </Button>
      </Grid.Row>
    ));

  timeFromNow = (timestamp) => moment(timestamp).fromNow();

  displayTags = (tags) =>
    tags.map((tag) => (
      <Label key={tag.id} text={tag.text} image>
        {tag.text}
        <Icon name="delete" />
      </Label>
    ));

  getArticlesToDisplay() {
    return this.state.admin
      ? this.state.articles.filter((ch) => ch.reported)
      : this.state.articles;
  }

  displayArticles = (articles) =>
    articles.length > 0 &&
    articles.map((article) => (
      <Segment name={article.name} details={article.details} color="blue">
        <Header as="h2">{article.name}</Header>

        <Container
          fluid
          style={{
            padding: 2,
            fontSize: 16,
            textAlign: "justify",
          }}
        >
          <td>{Parser(article.details)}</td>
          {/* <ReadMoreReact
            text={article.details}
            min={500}
            ideal={700}
            max={10000}
            readMoreText={
              <strong style={{ color: "#0fabbc" }}>Read more</strong>
            }
          /> */}
        </Container>
        <Divider />
        <span>
          {article.tags.map((tag) => (
            <Label icon="tag" color="green" content={tag.text} />
          ))}
        </span>
        <span style={{ float: "right" }}>
          <Icon
            style={{ marginLeft: 5 }}
            onClick={() => this.handleArticlesBookmark(article)}
            name={this.isBookmarked(article) ? "bookmark" : "bookmark outline"}
            color={this.isBookmarked(article) ? "yellow" : "black"}
          />
          <ArticlesLikeButton article={article} />
          {" | "}
          <ReportDropdown
            user={this.state.user}
            article={article}
            admin={this.state.admin}
          />
        </span>
      </Segment>
    ));

  addArticlesIcon() {
    return isAdmin(this.state.user.email) && !this.state.admin ? (
      <Label onClick={this.openModal} color="green">
        <Icon name="add" /> Add Article
      </Label>
    ) : null;
  }

  render() {
    const { contentModal, typeModal } = this.state;

    return (
      <React.Fragment>
        <Header as="h1">
          <span>
            <Icon name="sticky note outline" color="black" />{" "}
            {this.props.admin
              ? "Reported Articles"
              : this.props.bookmarkedArticles
              ? "Bookmarked Articles"
              : "Articles you can read"}{" "}
            ({this.getArticlesToDisplay().length}) {this.addArticlesIcon()}
          </span>
        </Header>
        <Item.Group divided>
          {this.displayArticles(this.getArticlesToDisplay())}
        </Item.Group>

        {/* Add Channel Content Modal */}
        <Modal basic open={contentModal} onClose={this.closeModal}>
          <Modal.Header>Add an Article</Modal.Header>
          <Modal.Content>
            <Form onSubmit={this.handleSubmit}>
              <Form.Field>
                <Input
                  fluid
                  label="Heading of your Article"
                  name="articleName"
                  onChange={this.handleChange}
                />
              </Form.Field>

              <Form.Field>
                <Editor
                  value={this.state.articleDetails}
                  initialValue="<p>This is the initial content of the editor</p>"
                  init={{
                    height: 500,
                    menubar: true,
                    plugins: [
                      "advlist autolink lists link image charmap print preview anchor",
                      "searchreplace visualblocks code fullscreen",
                      "insertdatetime table paste code help wordcount",
                    ],
                    toolbar:
                      "undo redo | formatselect | bold italic backcolor | \
              alignleft aligncenter alignright alignjustify | \
              bullist numlist outdent indent | removeformat | help",
                  }}
                  onEditorChange={this.handleEditorChange}
                />
                {/* <TextArea
                  style={{ height: 450 }}
                  fluid
                  placeholder="Write your heart out!!"
                  name="articleDetails"
                  onChange={this.handleChange}
                />  */}
              </Form.Field>
              <Form.Field>
                <InputTags
                  tags={(val) => this.setState({ articleTags: val })}
                />
              </Form.Field>
            </Form>
          </Modal.Content>

          <Modal.Actions>
            <Button color="green" inverted onClick={this.handleSubmit}>
              Add
            </Button>
            <Button color="red" inverted onClick={this.closeModal}>
              Cancel
            </Button>
          </Modal.Actions>
        </Modal>

        <Modal basic open={typeModal} onClose={this.closeModal}>
          <Modal.Actions>
            <Grid centred="true">
              {this.displayArticleTypes(ArticleTypesInfo)}
            </Grid>
          </Modal.Actions>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
});

export default connect(mapStateToProps)(Articles);



// WEBPACK FOOTER //
// ./src/components/SidePanel/Articles.js